import styled, { keyframes } from 'styled-components'
import { Flyout } from 'common-components'
import { COLORS } from 'consts/colors'
import { RADII, SHADOWS } from 'styles/consts'
import InfinitySvg from 'assets/svgr-icons/Infinity.svg'
import { getRatingColor } from '../ratingColor'

export {
  SubmenuFlyout,
  GroupItemWrapper,
  GroupItemHeader,
  GroupItemTitle,
  GroupChevron,
  ProviderIconFallback,
  SubmenuPanel,
  SubmenuVariantWrapper,
  SubmenuVariantHeader,
  SelectedCheck,
  MobileSubmenuWrapper,
  CrownBadgeIcon
} from 'containers/SubSidebar/shared/GroupedModelDropdown/ModelGroupItem/styled'

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
`

export const GroupRowFlex = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const GroupRowContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 6px;
`

export const TitleLine = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  min-width: 0;
`

export const IconTile = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: ${RADII.item};
  border: 1px solid ${COLORS.borderColor};
  background-color: ${COLORS.white};
`

const shineTrace = keyframes`
  from {
    stroke-dashoffset: 0;
  }
  to {
    stroke-dashoffset: -44;
  }
`

export const InfinityIconWrapper = styled.span`
  position: relative;
  flex-shrink: 0;
  width: 23px;
  height: 23px;
  display: inline-flex;
  overflow: visible;
  margin-left: 2px;
`

export const InfinityIconBase = styled(InfinitySvg)`
  width: 23px;
  height: 23px;
  overflow: visible;
`

export const InfinityIconShine = styled(InfinitySvg)`
  position: absolute;
  top: 0;
  left: 0;
  width: 23px;
  height: 23px;
  overflow: visible;

  path {
    stroke: ${COLORS.purple};
    stroke-dasharray: 10 34;
    animation: ${shineTrace} 3s linear infinite;
    filter: drop-shadow(0 0 1.5px #a09ae0);
  }
`

export const InfoIconAnchor = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

export const TooltipPanel = styled.div<{ $viewportShiftPx: number }>`
  position: relative;
  width: 310px;
  padding: 16px;
  border-radius: ${RADII.card};
  background-color: ${COLORS.secondaryExtraDark};
  color: ${COLORS.white};
  box-shadow: ${SHADOWS.menu};
  transform: translateX(
    calc(-50% + 10px + ${({ $viewportShiftPx }) => $viewportShiftPx}px)
  );
`

export const InfoTooltipFlyout = styled(Flyout)`
  box-shadow: none;
  background: transparent;
  border-radius: 0;
`

export const TooltipArrow = styled.div<{
  $side: 'top' | 'bottom'
  $viewportShiftPx: number
}>`
  position: absolute;
  left: 50%;
  transform: translateX(
    calc(-50% - ${({ $viewportShiftPx }) => $viewportShiftPx}px)
  );
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  ${({ $side }) =>
    $side === 'bottom'
      ? `
        bottom: -6px;
        border-top: 6px solid ${COLORS.secondaryExtraDark};
      `
      : `
        top: -6px;
        border-bottom: 6px solid ${COLORS.secondaryExtraDark};
      `}
`

export const DescriptionWrapper = styled.div`
  margin-top: 8px;
`

export const TooltipDivider = styled.hr`
  margin: 8px 0;
  border: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
`

export const QualityRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const QualityBarTrack = styled.div`
  flex: 1;
  height: 6px;
  border-radius: ${RADII.pill};
  background-color: rgba(255, 255, 255, 0.18);
  overflow: hidden;
`

export const QualityBarFill = styled.div<{ $score: number }>`
  height: 100%;
  width: ${({ $score }) => Math.max(0, Math.min(100, $score * 10))}%;
  background-color: ${({ $score }) => getRatingColor($score)};
  border-radius: ${RADII.pill};
`
